<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="comment-edit">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">{{form.modal.title}}</h4>
        </div>
        <div class="modal-body">
          <form @submit.prevent="form.onSubmit({updateList: false, comment: true})" @keydown="form.errors.clear($event.target.id)">
            <input type="hidden" name="id" v-model="form.data.id">

            <div class="form-group" :class="{'has-error': form.errors.has('body') }">
              <label class="control-label">Comment</label>
              <textarea class="form-control" id="body" v-model="form.data.body"></textarea>
              <span class="help-block" v-if="form.errors.has('body')" v-text="form.errors.get('body')"></span>
            </div>

            <loading-button :loading="form.loading" class="btn btn-primary" :disabled="form.errors.any()">Save</loading-button>
            <button type="button" class="btn btn-default" data-dismiss="modal">cancel</button>
          </form>
        </div>
        <div class="modal-footer">
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->
</template>

<script>
  import LoadingButton from '@/components/loading-button';

  export default {
    name: 'site-form',

    props: ['form'],

    components: {
      LoadingButton,
    },

  }

</script>